import { render, staticRenderFns } from "./GlobalModals.vue?vue&type=template&id=5e0cfd52"
import script from "./GlobalModals.vue?vue&type=script&lang=js"
export * from "./GlobalModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports